import { Formik } from "formik";

import { addPolicySchema } from "consts";
import { useKeystone, useUser } from "data/ss-data-hooks";
import { isError } from "data/ss-error";
import { trackEvent } from "utils";

import { AddPolicyForm } from "./add-policy-form";

export type AddPolicyFormSchema = {
  policyNumber: string;
  zipCode: string;
};

type AddPolicyModalProps = {
  data: { policyNumber?: string; zipCode?: string };
  show: boolean;
  handleClose: () => void;
  onAddPolicySuccess: (newPolicy: {
    newPolicyId?: string;
    zipCode?: string;
    origin?: string;
  }) => void;
};

export const AddPolicyModal = ({
  data,
  show,
  handleClose,
  onAddPolicySuccess,
}: AddPolicyModalProps) => {
  const keystone = useKeystone();
  const user = useUser();

  const handleSubmit = async (
    { policyNumber, zipCode },
    { resetForm, setStatus, setSubmitting },
  ) => {
    trackEvent("Add Policy Button Clicked");
    if (!user) return;
    const res = await keystone.linkPolicy(user.email, policyNumber, zipCode);

    if (isError(res)) {
      trackEvent("Error Displayed (Add Policy)", {
        errorMessage: res.message,
      });
      setStatus(res.message);
      setSubmitting(false);
      return;
    }

    onAddPolicySuccess({
      newPolicyId: policyNumber,
      zipCode,
      origin: data ? "Add Policy Email Enrollment" : "Direct",
    });
    resetForm();
    setSubmitting(false);
  };

  const initialValues: AddPolicyFormSchema = {
    policyNumber: data?.policyNumber ?? "",
    zipCode: data?.zipCode ?? "",
  };
  const shouldValidatePrefilledData = !!(data?.policyNumber || data?.zipCode);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={addPolicySchema}
      validateOnMount={shouldValidatePrefilledData}
      enableReinitialize
    >
      <AddPolicyForm handleClose={handleClose} show={show} />
    </Formik>
  );
};
